import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { v4 as uuidv4 } from "uuid";

@Injectable()
export class TraceIdInterceptor implements HttpInterceptor {
  private readonly HEADER_KEY = "x-trace-id";

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let traceId = req.headers.get(this.HEADER_KEY);

    if (!traceId) {
      traceId = uuidv4();
    }

    const cloned = req.clone({
      setHeaders: {
        [this.HEADER_KEY]: traceId,
      },
    });

    // Get user info from session storage
    const userJson = sessionStorage.getItem('user');
    let userId = 'anonymous';
    let username = 'anonymous';
    if (userJson) {
      try {
        const user = JSON.parse(userJson);
        userId = user.id || 'anonymous';
        username = user.fullname || 'anonymous';
      } catch (err) {
        console.warn('Failed to parse user from sessionStorage', err);
      }
    }
    
    // Extract path from URL (removes domain)
    const urlPath = new URL(req.url, window.location.origin).pathname;
    
    // send traceid event to Matomo
    if (window._paq) {
      // Set custom dimensions (replace 1,2,3 with IDs)
      window._paq.push(['setCustomDimension', 1, traceId]);
      window._paq.push(['setCustomDimension', 2, userId]);
      window._paq.push(['setCustomDimension', 3, username]);
      
      window._paq.push([
        'trackEvent',
        'API',
        req.method,
        `${traceId} | ${userId}/${username} | ${urlPath}`
      ]);
    }

    return next.handle(cloned);
  }
}
